import React from 'react'
import PropTypes from 'prop-types'
// import { Elements, StripeProvider } from 'react-stripe-elements'
import { loadStripe } from '@stripe/stripe-js';
import { Elements, ElementsConsumer } from '@stripe/react-stripe-js';
import GiftcardsPage from './GiftcardsPage'


const InjectedCheckoutForm = ({ skus }) => (
  <ElementsConsumer>
    {({ stripe, elements }) => (
      <GiftcardsPage skus={skus} stripe={stripe} elements={elements} />
    )}
  </ElementsConsumer>
)

InjectedCheckoutForm.propTypes = {
  skus: PropTypes.instanceOf(Array).isRequired
}

// eslint-disable-next-line no-undef
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY)

const StripeGiftcardsWrapper = ({ skus }) => (
  <Elements stripe={stripePromise}>
    <InjectedCheckoutForm skus={skus} />
  </Elements>
)

StripeGiftcardsWrapper.propTypes = {
  skus: PropTypes.arrayOf(PropTypes.object)
}

StripeGiftcardsWrapper.defaultProps = {
  skus: []
}

export default StripeGiftcardsWrapper